import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getLcgEligibility = {
  name: "getLcgEligibility" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    count: z.number(),
    homeCountryCodes: z.array(z.string()),
    fetchedAt: z.date(),
    cached: z.boolean(),
    unavailable: z.boolean(),
    eligible: z.boolean(),
    windowDays: z.number(),
    minOrders: z.number(),
  }),
};
